import createLogger from '@techstyle/debug';

export default createLogger('@techstyle/fabletics-react');
